<template>
  <div class="category-filter">
    <div
      v-for="category in categories"
      :key="category.id"
      class="category-wrap"
      :class="{ active: openedCategories[category.id] }"
    >
      <div
        class="category text-button"
        @click="toggleSubcategories(category.id)"
      >
        {{ category.name }}
      </div>
      <div v-if="category.children && category.children" class="subcategories">
        <template v-if="links">
          <nuxt-link
            v-for="subcat in category.children"
            :key="subcat.id"
            class="text-button"
            :to="
              subcat.slug
                ? `/${subcat.slug}/`
                : `/search/?category_id=${subcat.id}${withoutSlugQuery}`
            "
            @click="clearMobileScroll"
          >
            {{ subcat.name }}
          </nuxt-link>
        </template>
        <template v-else>
          <div
            v-for="subcat in category.children"
            :key="subcat.id"
            class="text-button"
            :class="{ active: active && subcat.id === active.id }"
            @click="$emit('change', subcat)"
          >
            {{ subcat.name }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  name: 'CategoryFilter',
  props: {
    categories: {
      type: Array as any,
      required: true,
    },
    active: {
      type: Object as any,
      default: () => {},
    },
    links: Boolean,
    withoutSlugQuery: {
      type: String,
      default: '',
    },
  },
  emits: ['change'],
  setup() {
    const openedCategories = ref<any>({});

    function toggleSubcategories(id: string) {
      openedCategories.value = {
        ...openedCategories.value,
        [id]: !openedCategories.value[id],
      };
    }

    const clearMobileScroll = () => {
      document.body.classList.remove('tablet-overflow-hidden');
      document.body.style.paddingRight = '';
    };

    return {
      openedCategories,
      toggleSubcategories,
      clearMobileScroll,
    };
  },
});
</script>

<style scoped lang="scss" src="./CategoryFilterScss.scss" />
